import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

// Components
import { WithCard } from './WithCard';
import { DefaultLayout } from './DefaultLayout';
import { WithNotification } from './WithNotification';

export type CallToActionProps = SliceComponentProps<Content.CallToActionSlice>;

const CallToAction = ({ slice }: CallToActionProps) => {
  const { variation } = slice;

  return (
    <>
      {variation === 'withCard' && <WithCard slice={slice} />}
      {variation === 'default' && <DefaultLayout slice={slice} />}
      {variation === 'withNotification' && <WithNotification slice={slice} />}
    </>
  );
};

export default CallToAction;
